const PoweredBy = ({ direction = 'column' }) => {
  const cx = direction === 'row' ? 'justify-center' : 'place-items-end';

  return (
    <div className={`gap-sm flex-${direction} align-center items-center ${cx}`}>
      <p className='text-secondary text-sm'>Powered by</p>
      <a href={'http://www.carbonclick.com/'} target='_blank' rel="noopener noreferrer">
        <img
          style={{ maxHeight: 18 }}
          src={`https://res.cloudinary.com/carbonclick/image/upload/v1688642102/Merchant%20Portal/new-logo_j8usbf.svg`}
          alt="CarbonClick logo"
        />
      </a>
    </div>
  )
};

export default PoweredBy;
